//Generated File 
export default class StringConstants{
	static readonly CRITERIA = `criteria`;
	static readonly CRITERIA_REPLACE_STR = `[criteria]`;
	static readonly DB_DEFAULT = `dbdefault`;
	static readonly DECIMAL_NUMBER_REGEX = `[\.0-9]`;
	static readonly DEFAULT = `default`;
	static readonly DELETE = `delete`;
	static readonly DIMENSION_NULL_ARABIC_CODE = `عام`;
	static readonly DIMENSION_NULL_CODE = `PUBLIC`;
	static readonly DOT_REGEX = `\.`;
	static readonly FreeLineStyle = `dataGridFreeLine`;
	static readonly ID_SANITIZER_REGEX = `[^A-Za-z0-9\\\/]`;
	static readonly ID_SANITIZER_REGEX_WITHOUT_DOT = `[^\.A-Za-z0-9\\\/]`;
	static readonly INSERTION_COUNT = `insertionCuont`;
	static readonly InvalidSentLineStyle = `dataGridInvalidSentRow`;
	static readonly LAYOUT_PREFERENCES_PATH = `/preferences/users/{0}/{1}/{2}`;
	static readonly LAYOUT_PREFERENCES_PATH_PREFIX = `/preferences/users/`;
	static readonly LAYOUT_PROCESSED_PATH = `/preferences/layouts/processed/{0}/{1}`;
	static readonly LAYOUT_UNPROCESSED_PATH = `/preferences/layouts/{0}/{1}`;
	static readonly LAYOUT_UNPROESSED_ROOT_FOLDER = `/preferences/layouts/{0}`;
	static readonly LeafItemStyle = `dataGridL1Row`;
	static readonly MARKER_END = `]`;
	static readonly MARKER_START = `[`;
	static readonly MAX_STRING = `ييييييييييييييييييييييي`;
	static readonly MiddleItemStyle = `dataGridL2Row`;
	static readonly NAMA_ROW_BACKGROUND_COLOR = `namaRowBackgroundColor`;
	static readonly NAMA_STYLE_FIELDID = `namaStyle`;
	static readonly ORDER = `order`;
	static readonly ORDER_BY_REPLACE_STR = `[order]`;
	static readonly ParentItemStyle = `dataGridL3Row`;
	static readonly REGEX_OR = `|`;
	static readonly ROW_BACKGROUND_COLOR = `rowBackgroundColor`;
	static readonly ReturnedItemStyle = `dataGridReturnedRow`;
	static readonly SELECTOR = `selector`;
	static readonly SLASH = `/`;
	static readonly SentLineStyle = `dataGridSentRow`;
	static readonly SlaveLineStyle = `dataGridSlaveLine`;
	static readonly TermConfigScreen = `TermConfigScreen`;
	static readonly _id = `_id`;
	static readonly dateFormat = `dd-MM-yyyy`;
	static readonly dateTimeFormat = `yyyy-MM-dd'T'HH:mm:ss.SSS`;
	static readonly editableDateTimeFormat = `yyyy-MM-dd HH:mm`;
	static readonly editableTimeFormat = `HH:mm`;
	static readonly legacyUIExtraStyles = `legacyUIExtraStyles`;
	static readonly listViewTimeFormat = `HH:mm:ss`;
	static readonly timeFormat = `hh:mm:ss aaa`;
}
